<app-hvb-header></app-hvb-header>
<img class="background-image" alt="HVB about background" src="../../../assets/img/start-page/HVB_about_page_background_page.png">
<div class="section-1">
  <div class="section-container">
    <div></div>
    <div></div>
    <div class="img-container"></div>
    <div class="title">
      {{'aboutPage.section1.title'|translate}}
    </div>
    <div class="subtitle">
      {{'aboutPage.section1.subtitle'|translate}}
    </div>
    <div class="content">
      <markdown [data]="(about$|async)?.attributes.wasGeschieht"></markdown>
    </div>
  </div>
</div>
<div class="section-2">
  <div class="grid">
    <div class="placeholder-top"></div>
    <div class="title">{{'aboutPage.section2.title'|translate}}</div>
    <div class="subtitle">{{'aboutPage.section2.subtitle'|translate}}</div>
    <div class="content">
      <markdown [data]="(about$|async)?.attributes.historiePart1"></markdown>
    </div>
    <div class="white-box">
      <markdown [data]="(about$|async)?.attributes.auszugBoersenordnung"></markdown>
    </div>
    <div class="content">
      <markdown [data]="(about$|async)?.attributes.historiePart2"></markdown>
    </div>
  </div>
</div>
<div class="section-tour">
  <div class="grid">
    <div class="placeholder-top"></div>
    <div class="title">{{'aboutPage.sectionTour.title'|translate}}</div>
    <div class="subtitle">{{'aboutPage.sectionTour.subtitle'|translate}}</div>
    <div class="content">
      <markdown [data]="(about$|async)?.attributes.boersenfuehrung"></markdown>
    </div>

    <div class="white-box">
      <span>{{'aboutPage.sectionTour.tip.title'|translate}}</span>
      <markdown [data]="(about$|async)?.attributes.boersenfuehrungTipp"></markdown>
    </div>
  </div>
</div>
<div class="section-3">
  <div class="title-section">
    <div class="title">{{'aboutPage.section3.title'|translate}}</div>
    <div class="subtitle"><markdown [data]="(about$|async)?.attributes.boersenvorstand"></markdown></div>
  </div>
  <div class="grid">
    <ng-container *ngFor="let member of (boardMembers$|async)">
      <div class="item">
        <div class="name">
          {{ member.attributes.name }}
        </div>
        <markdown [data]="member.attributes.position"></markdown>
      </div>
    </ng-container>
  </div>
</div>
<hvb-footer></hvb-footer>
